import script from "./Privacy_Policy.vue?vue&type=script&setup=true&lang=js"
export * from "./Privacy_Policy.vue?vue&type=script&setup=true&lang=js"

import "./Privacy_Policy.vue?vue&type=style&index=0&id=4afb2922&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4afb2922"]])

export default __exports__